'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

import mixpanel from 'mixpanel-browser';

import useUser from '@/utils/hooks/swr/useUser';

export default function MixPanelInitializeUser() {
    const pathname = usePathname();
    const { user } = useUser();

    useEffect(() => {
        mixpanel.identify(String(user.admin_id));

        /**
         * set user properties
         */
        mixpanel.people.set({
            $email: user.email,
            $user_id: user.id,
            $first_name: user?.first_name ?? '',
            $last_name: user?.last_name ?? ''
        });
    }, [user]);

    useEffect(() => {
        if (pathname) {
            mixpanel.track_pageview({ page: pathname });
        }
    }, [pathname]);

    return null;
}
